/** Preferências guardadas no aparelho. Tudo protegido: o jogo funciona mesmo sem armazenamento. */

const memory = new Map<string, string>();

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return memory.get(key) ?? null;
  }
}

function set(key: string, value: string): void {
  memory.set(key, value);
  try {
    localStorage.setItem(key, value);
  } catch {
    /* modo anônimo ou armazenamento bloqueado */
  }
}

/** Identificação secreta deste aparelho (não é dado pessoal: só um número aleatório). */
export function deviceToken(): string {
  let t = get('tt:token');
  if (!t || !/^[a-f0-9]{32}$/.test(t)) {
    const b = crypto.getRandomValues(new Uint8Array(16));
    t = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    set('tt:token', t);
  }
  return t;
}

export const savedName = () => get('tt:name') ?? '';
export const saveName = (name: string) => set('tt:name', name);

export const prefs = {
  reducedEffects: () => get('tt:reduced') === '1' || matchMedia('(prefers-reduced-motion: reduce)').matches,
  setReducedEffects: (on: boolean) => set('tt:reduced', on ? '1' : '0'),
  mutedTaunts: () => get('tt:mutedTaunts') === '1',
  setMutedTaunts: (on: boolean) => set('tt:mutedTaunts', on ? '1' : '0'),
  /** Mudo geral (botão sempre visível na barra do topo). */
  muted: () => get('tt:muted') === '1',
  setMuted: (on: boolean) => set('tt:muted', on ? '1' : '0'),
  music: () => get('tt:music') !== '0',
  setMusic: (on: boolean) => set('tt:music', on ? '1' : '0'),
  soundFx: () => get('tt:sfx') !== '0',
  setSoundFx: (on: boolean) => set('tt:sfx', on ? '1' : '0'),
  voice: () => get('tt:voice') !== '0',
  setVoice: (on: boolean) => set('tt:voice', on ? '1' : '0'),
  /** Volume geral (efeitos, passos, personagens, locutor), de 0 a 1. */
  volume: () => vol('tt:vol', 0.9),
  setVolume: (v: number) => set('tt:vol', String(clamp01(v))),
  /** Volume só da música, de 0 a 1. */
  musicVolume: () => vol('tt:musicVol', 0.7),
  setMusicVolume: (v: number) => set('tt:musicVol', String(clamp01(v))),
};

function clamp01(v: number): number {
  return Math.max(0, Math.min(1, Number.isFinite(v) ? v : 0));
}

function vol(key: string, fallback: number): number {
  const raw = get(key);
  return raw === null ? fallback : clamp01(Number(raw));
}
